/* Suresh Peddavoora 10/28/2022 2701127043  Added Class Name for Text Fields and Buttons */
import React, {useState, useContext} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
const AddRuleForm = ({
  setOpen,
  fieldCode,
  formData,
  setFormData,
  rowData,
  isEditMode,
  oldRuleCode,
  setIsEditMode,
  sqlSNo,
}) => {
  const [expression, setExpression] = useState(
    isEditMode && rowData && rowData.expression ? rowData.expression : '',
  );
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const initialValues = {
    ruleCode:
      isEditMode && rowData && rowData.ruleCode ?
        rowData.ruleCode :
        sqlSNo ?
          sqlSNo < 10 ?
            'S0' + sqlSNo :
            'S' + sqlSNo :
          '',
    returnType: isEditMode && rowData && rowData.returnType ? rowData.returnType : '',
    expression: expression ? expression : isEditMode && rowData && rowData.expression ? rowData.expression : '',
  };

  // const [currentRuleCode, setCurrentRuleCode] = useState(rowData?.ruleCode || '');
  const currentRuleCode = rowData?.ruleCode || '';

  const schema = Yup.object().shape({
    ruleCode:
      rowData?.ruleCode === currentRuleCode && isEditMode ?
        '' :
        Yup.string()
          .notOneOf(
            formData.map((data) => data.ruleCode),
            'Rule code already exists',
          )
          .required('Rule Code is required'),
    expression: Yup.string().required('Expression is required'),
  });

  const handleSubmit = (values) => {
    values.ruleCode = values.ruleCode.toUpperCase();
    const data = {...values};
    const copyData = [...formData];

    if (!isEditMode) {
      copyData.push({...data, expression: expression, tableData: {checked: true}});
      setFormData(copyData);
      setOpen(false);
    } else {
      const updatedData = copyData.map((each) => {
        if (each.ruleCode === oldRuleCode) {
          return {
            ...each,
            ruleCode: data.ruleCode,
            returnType: data.returnType,
            expression: expression,
          };
        } else {
          return {...each};
        }
      });
      setFormData(updatedData);
      setOpen(false);
      setIsEditMode(false);
    }
  };
  const handleFieldCode = (code) => {
    const getCode = code;
    setExpression(expression + getCode);
  };

  return (
    <>
      <div className={classes.dialoguecardStyles}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {values, handleChange, handleSubmit, handleReset, handleBlur, touched, errors, resetForm} =
              props;
            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div className="global-field-textfields">
                    <ErrorBoundaryForComponents>
                      <Grid container spacing={2}>
                        <Grid item xs={6} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Rule Code`}
                            label="Rule Code"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="ruleCode"
                            disabled
                            value={values.ruleCode}
                            fullWidth
                            error={Boolean(touched.ruleCode && errors.ruleCode)}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.ruleCode && errors.ruleCode && errors.ruleCode}
                          </FormHelperText>
                        </Grid>
                        <div className={fieldCode?.length > 0 ? 'add-rule-chips form-group w-100' : ''}>
                          {fieldCode?.length > 0 ?
                            fieldCode.map((item) => (
                              <Grid className="px-2" key={item}>
                                <div className="tag-item" key={item}>
                                  <Chip
                                    label={item}
                                    onClick={() => handleFieldCode(item)}
                                  />
                                </div>
                              </Grid>
                            )) :
                            null}
                        </div>
                        <Grid item xs={12} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Expression`}
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            label="Expression"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="expression"
                            value={values.expression}
                            required
                            onChange={(e) => {
                              setExpression(e.target.value);
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.expression}
                            error={Boolean(touched.expression && errors.expression)}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.expression && errors.expression && errors.expression}
                          </FormHelperText>
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                  <div className="button-spacing-mb">
                    <Button
                      variant="outlined"
                      onClick={() => {
                        resetForm(initialValues); setExpression('');
                      }}
                      className={`reset-btn mx-1`}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn mx-1`}
                    >
                      {isEditMode ? 'Update Rule' : 'Add Rule'}
                    </Button>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default AddRuleForm;
